import { useEffect, useState } from "react";

export function usePromiseData<T = any>(
  promise: (pageNumber: number) => Promise<T>,
  options: { onError?: (e: any) => void } = {}
) {
  const [isLoading, setIsLoading] = useState(false);
  const [result, setResult] = useState<T>();
  const [currentPage, setCurrentPage] = useState(0);

  const handlePromise = async (pageNumber: number = currentPage) => {
    setIsLoading(true);
    try {
      const result = await promise(pageNumber);
      setResult(result);
    } catch (e) {
      options.onError?.(e);
    } finally {
      setIsLoading(false);
    }
  };

  const nextPage = () => setCurrentPage((prev) => prev + 1);
  const prevPage = () => setCurrentPage((prev) => Math.max(0, prev - 1));
  const setPage = (page: number) => setCurrentPage(Math.max(0, page));

  useEffect(() => {
    handlePromise(currentPage);
  }, [currentPage]);

  const onUpdate = async (newResult?: T) => {
    if (newResult !== undefined) {
      setResult(newResult);
    } else {
      await handlePromise();
    }
  };

  return {
    isLoading,
    result,
    onUpdate,
    setResult,
    nextPage,
    prevPage,
    setPage,
    currentPage
  };
}
